/**
 * Check if the current code is running in server (Node | SSR)
 * @returns boolean
 */
function isServer() {
  return !(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
  );
}

export default isServer;
